import {
  faFacebook,
  faInstagram,
  faReddit,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import config from "../config";

function Header() {
  return (
    <header className="header sticky sticky-top">
      <a onClick={(e)=>{e.preventDefault();
        if(window.location.pathname !== '/') {
          window.open(config.HOST, '_BLANK')
        } else {
          document.getElementById('section-hero')?.scrollIntoView()
        }
      }}>
        <svg
          id="Logo"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 120.78 127.19"
        >
          <path d="m86.57,127.02c-6.8,0-13.05-1.93-18.75-5.79s-9.76-9.19-12.18-15.98c-1.15-3.8-1.73-7.37-1.73-10.71,0-6.22,1.56-12.1,4.67-17.63,1.38-2.3,2.94-4.43,4.67-6.39s4.15-4.49,7.26-7.6c2.99-3.11,5.33-5.7,7-7.78,1.67-2.07,2.91-4.38,3.72-6.91.58-1.5.86-2.76.86-3.8,0-1.38-.35-2.48-1.04-3.28-.69-.8-1.56-1.21-2.59-1.21-1.38,0-2.65.63-3.8,1.9-1.61,1.96-3.05,4.67-4.32,8.12-.46,1.38-.98,2.65-1.56,3.8l-1.21,3.28c-1.84,4.84-3.28,8.35-4.32,10.54-2.42,5.07-5.62,9.36-9.59,12.87-3.97,3.52-8.38,5.27-13.22,5.27-2.19,0-4.44-.4-6.74-1.21-3.92-1.15-7.11-3.69-9.59-7.6-2.48-3.91-3.72-8.29-3.72-13.13,0-3.46.69-6.77,2.07-9.94,1.38-3.17,3.51-6.07,6.39-8.73,2.3-2.19,4.89-3.92,7.78-5.18,2.88-1.27,5.7-1.9,8.47-1.9,1.38,0,2.85.17,4.41.52s2.56.58,3.02.69c.46.12,1.47.35,3.02.69,1.56.35,2.96.52,4.23.52s2.42-.17,3.46-.52c2.19-.69,4.03-2.04,5.53-4.06,1.5-2.01,2.42-4.29,2.76-6.83.58-6.91-.95-12.24-4.58-15.98s-8.38-5.62-14.26-5.62c-5.18,0-10.48,1.44-15.9,4.32s-10.34,7.11-14.77,12.7c-4.44,5.59-7.69,12.36-9.76,20.3-1.04,4.49-1.56,8.7-1.56,12.61,0,7.49,1.73,13.85,5.18,19.09,3.46,5.24,7.72,9.24,12.79,12.01,2.42,1.15,4.61,2.13,6.57,2.94,2.65,1.04,4.78,2.02,6.39,2.94,3.69,1.73,6.51,4.21,8.47,7.43,1.96,3.23,2.94,6.63,2.94,10.2,0,2.88-.69,5.47-2.07,7.78-3.34,4.95-8.12,7.43-14.34,7.43-4.49,0-9.07-1.38-13.74-4.15-4.67-2.76-8.55-6.45-11.66-11.06-3.57-4.72-6.34-10.83-8.29-18.32-1.96-7.49-2.94-15.38-2.94-23.67,0-10.25,1.5-19.47,4.49-27.65,3.46-9.44,7.66-17.22,12.61-23.33,4.95-6.1,11.58-11,19.87-14.69C43.3,1.44,49.12,0,54.42,0c4.95,0,9.39,1.15,13.31,3.46s6.97,5.7,9.16,10.2c1.27,2.42,1.9,5.07,1.9,7.95,0,3.57-.89,7.08-2.68,10.54-1.79,3.46-4,6.37-6.65,8.73s-5.18,3.83-7.6,4.41c-1.38.46-2.94.69-4.67.69-1.27,0-3.05-.23-5.36-.69-.58-.11-1.21-.23-1.9-.35-.69-.11-1.56-.17-2.59-.17-2.76,0-5.42,1.1-7.95,3.28-2.31,2.31-3.46,4.95-3.46,7.95,0,2.76.95,5.24,2.85,7.43s4.23,3.28,7,3.28c2.42,0,4.78-.92,7.08-2.76,1.84-1.38,4.49-4.17,7.95-8.38,3.46-4.2,5.7-7.11,6.74-8.73,3.11-5.3,6.51-9.7,10.2-13.22,3.69-3.51,7.37-5.27,11.06-5.27,1.61,0,3.34.46,5.18,1.38,2.3,1.27,3.46,3.46,3.46,6.57,0,2.19-.58,4.47-1.73,6.83s-2.71,4.47-4.67,6.31c-.46.35-1.5,1.27-3.11,2.76-1.61,1.5-3.46,3.23-5.53,5.18-4.26,3.8-7.89,7.4-10.89,10.8s-5.36,7.11-7.08,11.15c-1.38,3.8-2.07,7.37-2.07,10.71,0,3,.49,5.93,1.47,8.81s2.45,5.36,4.41,7.43c1.5,1.61,3.74,3.17,6.74,4.67,2.65,1.04,5.3,1.56,7.95,1.56,3.57,0,6.97-.86,10.2-2.59,3.22-1.73,5.7-4.15,7.43-7.26,1.27-1.96,1.9-3.91,1.9-5.88,0-2.07-.63-3.8-1.9-5.18-1.27-1.38-3.05-2.07-5.36-2.07-1.84,0-3.92.52-6.22,1.56-2.76.92-4.67,1.38-5.7,1.38-3.23,0-6.13-1.27-8.73-3.8-2.59-2.53-3.89-5.76-3.89-9.68,0-1.38.4-3.4,1.21-6.05,1.5-3.57,4.12-6.48,7.86-8.73s7.92-3.37,12.53-3.37c5.88,0,11.4,2.02,16.59,6.05,3.91,3.11,6.88,6.94,8.9,11.49,2.01,4.55,3.02,9.36,3.02,14.43,0,5.65-1.27,10.95-3.8,15.9-1.61,3.23-3.74,6.16-6.39,8.81s-5.76,4.67-9.33,6.05c-4.84,2.3-9.74,3.45-14.69,3.45Z" />
        </svg>
      </a>

      <ul className="header-list">
        <li>
          <a
            href="https://www.instagram.com/rouse_drink"
            className="header-link"
            target="_BLANK"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              className="social-icon md hydrated"
              icon={faInstagram}
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/rousedrink"
            className="header-link"
            target="_BLANK"
          >
            <FontAwesomeIcon
              className="social-icon md hydrated"
              icon={faFacebook}
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.tiktok.com/@rousedrink"
            className="header-link"
            target="_BLANK"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              className="social-icon md hydrated"
              icon={faTiktok}
            />
          </a>
        </li>
        <li>
          <a
            href="https://www.reddit.com/r/rousedrink"
            className="header-link"
            target="_BLANK"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              className="social-icon md hydrated"
              icon={faReddit}
            />
          </a>
        </li>
      </ul>
    </header>
  );
}

export default Header;
